const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN;

export interface GeocodeResult {
  latitude: number;
  longitude: number;
  placeName: string;
  country: string;
  city: string;
  state: string;
  postalCode: string;
  line1: string;
}

/**
 * Forward geocoding — iz tekstualne adrese dohvaća koordinate (pin)
 * i strukturirane dijelove adrese (država, grad, županija, poštanski broj).
 *
 * Rezultat se traži na engleskom (`language=en`) jer aplikacija koristi
 * engleske nazive država (EUROPEAN_COUNTRIES), pa se tako poklapaju s dropdownom.
 */
export const geocodeAddress = async (address: string): Promise<GeocodeResult | null> => {
  if (!address || address.trim().length < 3) return null;

  try {
    const res = await fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
        address
      )}.json?access_token=${MAPBOX_TOKEN}&limit=1&language=en`
    );
    const data = await res.json();

    const feature = data?.features?.[0];
    if (!feature) return null;

    const [longitude, latitude] = feature.center ?? [];
    if (latitude == null || longitude == null) return null;

    const context = feature.context || [];
    let country = "";
    let city = "";
    let state = "";
    let postalCode = "";

    context.forEach((item: any) => {
      if (item.id.startsWith("country")) {
        country = item.text;
      } else if (item.id.startsWith("place")) {
        city = item.text;
      } else if (item.id.startsWith("region")) {
        state = item.text;
      } else if (item.id.startsWith("postcode")) {
        postalCode = item.text;
      }
    });

    return {
      latitude,
      longitude,
      placeName: feature.place_name ?? address,
      country,
      city,
      state,
      postalCode,
      line1: feature.text ?? "",
    };
  } catch {
    return null;
  }
};
